
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatingResponse } from '../../interfaces/paginating.response';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css']
})
export class PaginatorComponent {

  @Output() changePaginator = new EventEmitter<{ limit: number; page: number; }>();
  @Input() pageSizes: number[] = [50, 100];
  @Input() state: PaginatingResponse;

  onChangePage(page: number): void {
    this.state.page = page;
    this.update();
  }

  onChangeLimit(limit: number): void {
    this.state.limit = limit;
    this.update();
  }

  private update(): void {
    this.changePaginator.emit({
      limit: this.state.limit,
      page: this.state.page,
    });
  }
}
